var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventTaboola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.55835)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.5583,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#004A7A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_726_8749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3535 41.0518C38.7054 41.0367 38.3374 43.6115 38.3261 45.5516C38.3148 47.4935 38.6529 50.1077 41.299 50.1246C43.9452 50.1396 44.3152 47.531 44.3265 45.5873C44.3396 43.6453 44.0015 41.0668 41.3535 41.0518ZM41.2709 55.2066C34.3878 55.1672 31.3078 50.5941 31.3379 45.5121C31.3679 40.4283 34.4986 35.9284 41.3835 35.9698C48.2666 36.0073 51.3466 40.5428 51.3165 45.6267C51.2865 50.7106 48.1539 55.2461 41.2709 55.2066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6972 41.0518C56.051 41.0349 55.6829 43.6115 55.6717 45.5534C55.6585 47.4953 55.9966 50.1077 58.6446 50.1246C61.2889 50.1396 61.6589 47.531 61.6702 45.5891C61.6833 43.6453 61.3453 41.0668 58.6972 41.0518ZM58.6146 55.2066C51.7334 55.1653 48.6534 50.5923 48.6834 45.5103C48.7116 40.4283 51.8442 35.9284 58.7273 35.9698C65.6103 36.0092 68.6903 40.5447 68.6621 45.6267C68.6302 50.7106 65.4976 55.2461 58.6146 55.2066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9596 55.2065C38.9214 57.4226 44.071 58.4086 49.6826 58.4405C55.5759 58.4762 60.0457 57.3625 65.7042 55.2065L65.6704 61.3121C60.6053 63.823 55.1139 65.1771 49.6413 65.1471C43.6766 65.1114 39.3777 63.8869 33.922 61.3121L33.9596 55.2065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_726_8749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 30.9878,
    fill: "white",
    transform: "translate(30.75 35.0645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventTaboola);
export default __webpack_public_path__ + "static/media/canvas_event_taboola.0704a465bcb8df84f9bdcf625f6f9a36.svg";
export { ForwardRef as ReactComponent };